export const cardNumberId = 'cardNumberCont';
export const cardExpiryId = 'cardExpiryCont';
export const cardCvcId = 'cardCvcCont';
